export default "__VITE_ASSET__BVKdC6cf__"